import { render } from "./AppTechnical.vue?vue&type=template&id=bf2406ce"
import script from "./AppTechnical.vue?vue&type=script&lang=js"
export * from "./AppTechnical.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__